export default {
  inited: false,
  online: false
}
